import { useGlobalState } from "@/hooks/useGlobalState";
import { Product } from "@/types/product";
import { formatPrice } from "./format-price";

export const getProductVariantData = (product: Product | null) => {
  const { config } = useGlobalState();

  if (!product) {
    return { variantToShow: null, image: "", imageAlt: "", formattedPrice: "" };
  }

  const hasVariants = product.variants && product.variants.length > 0;
  const variantToShow =
    hasVariants && product.primary_variant_id
      ? product.variants.find(
          (variant: Product["variants"][number]) =>
            variant.id === product.primary_variant_id,
        )
      : product.variants?.[0];
  const variantImageSrc = variantToShow?.image?.url || product.images?.[0]?.src;
  const formattedPrice = formatPrice(
    variantToShow?.price?.toString(),
    config?.shop.money_format,
  );

  config?.shop.money_format?.replace(
    /{{[^}]+}}/,
    variantToShow?.price || "N/A",
  );
  const image = variantImageSrc || product.images?.[0]?.src || "";
  const imageAlt = product.images?.[0]?.alt_text || product.title;

  return { variantToShow, image, imageAlt, formattedPrice };
};
